import { isPlatformBrowser } from '@angular/common';
import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'covid-search',
    template: `
        <smt-flyto
            apikey="29ea3621-26bc-4791-99bb-de54239dcc79"
            [lang]="lang"
            class="smt-flyto"
            withdisclaimer="disabled">
        </smt-flyto>
    `,
    styleUrls: ['./covid-search.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CovidSearchComponent implements OnInit {
    @Input() lang: string
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onLoad = new EventEmitter()

    constructor(@Inject(PLATFORM_ID) private platformId: string) {}

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.insertScript();
            document.addEventListener('smtWidgetInfoLoaded', this.initializeWidget);
        }
    }

    initializeWidget = () => {
        const discl = document.querySelector('.trigger')
        if (discl) {
            discl.classList.remove('hide');
        }
        this.onLoad.emit();
    }

    insertScript = () => {
        if (window && !window['SmtBootCWidget']) {
            const prod = 'https://cdn.smartvel.com/scripts/cwidget/boot.min.js';
            let $script = document.createElement('script');
            $script.src = prod;
            document.body.appendChild($script);
        }
    }

}
